import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidateApartment, ValidateCity, ValidateStreet } from '../validators/personalInfo-address.validator';
import { I18nService } from 'src/app/service/i18n.service';
import { FrameworkUtilityComponent } from 'src/app/form-utlity/framework-utility';
import { EnvironmentConfig } from 'src/environments/environmentConfig';
import { UtilService } from "src/app/service/util.service";
import { ActivatedRoute, Router } from '@angular/router';
declare var google: any;
@Component({
  selector: 'app-estimated-value-of-home',
  templateUrl: './estimated-value-of-home.component.html',
  styleUrls: ['./estimated-value-of-home.component.less'],
  providers: [FrameworkUtilityComponent, EnvironmentConfig]
})
export class EstimatedValueOfHomeComponent implements OnInit {
  estimate: FormGroup;
  isSelected: boolean = false
  selected: boolean = false;
  provinceColor: boolean = true
  selCode: boolean = false;
  streetColor: boolean = true;
  address = {};
  postalColor: boolean = true
  dummyAddress: any;
  colorPostal: boolean = false;
  addressForm: FormGroup;
  address1Field: HTMLInputElement;
  cityColor: boolean = true
  postalField: HTMLInputElement;
  address2Field: HTMLInputElement;
  autocomplete: google.maps.places.Autocomplete;
  provinceOptions: any = [];
  selectedRadio = '';
  currentLang: any;
  isIos: boolean;
  lang: boolean;
  submitted: boolean = false;
  preQualData: any;
  propertyValue = '';
  displayValidation = false;

  propertyValueNew: number;
  addressline1: any;
  city: any;
  province: any;
  postal_code: any;
  address1line: any;
  apartment: any;
  apartmentConfirmed: any;
  cityConfirmed: any;
  provinceConfirmed: any;
  postalConfirmed: any;
  submittedamount: boolean = false;


  constructor(private fb: FormBuilder, private i18nService: I18nService, private formUtiObj: FrameworkUtilityComponent, private util: UtilService, private router: Router, private _activatedRoute: ActivatedRoute) {
    this.isIos = !!navigator.platform && /iPad|Mac|iPhone|iPod/.test(navigator.platform);
    this.addressForm = this.fb.group({
      streetName: ['', [Validators.required, ValidateStreet]],
      apartment: ['', [ValidateApartment]],
      city: ['', [Validators.required, ValidateCity]],
      province: ['', Validators.required],
      postalCode: ['', [Validators.required, Validators.pattern('[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]')]],
      address: new FormControl('', Validators.required)
    });
    this.addressForm.get("streetName").valueChanges.subscribe(x => {
      this.address1Field = document.getElementById("streetName") as HTMLInputElement
    });
    this.addressForm.get("streetName").valueChanges.subscribe(x => {
      this.address1Field = document.getElementById("streetName") as HTMLInputElement
    });
    this.provinceOptions = [
      { code: "AB", nameEn: "Alberta", nameFr: "Alberta" },
      { code: "BC", nameEn: "British Columbia", nameFr: "Colombie-Britannique" },
      { code: "MB", nameEn: "Manitoba", nameFr: "Manitoba" },
      { code: "NB", nameEn: "New Brunswick", nameFr: "Nouveau-Brunswick" },
      { code: "NL", nameEn: "Newfoundland/Labrador", nameFr: "Terre-Neuve-et-Labrador" },
      { code: "NS", nameEn: "Nova Scotia", nameFr: "Nouvelle-Écosse" },
      { code: "NT", nameEn: "Northwest Territories", nameFr: "Territoires du Nord-Ouest" },
      { code: "NU", nameEn: "Nunavut", nameFr: "Nunavut" },
      { code: "ON", nameEn: "Ontario", nameFr: "Ontario" },
      { code: "PE", nameEn: "Prince Edward Island", nameFr: "Île-du-Prince-Édouard" },
      { code: "QC", nameEn: "Quebec", nameFr: "Québec" },
      { code: "SK", nameEn: "Saskatchewan", nameFr: "Saskatchewan" },
      { code: "YT", nameEn: "Yukon", nameFr: "Yukon" },
    ]

  }

  ngOnInit(): void {
    this.selectedRadio = 'address';
    this.preQualData = this.util.getSessionStorage();
    this.currentLang = this.i18nService.getCurrentLang();
    console.log(this.currentLang, "lang")
    if (this.currentLang == "en") {
      this.lang = true;
    }
    if (this.currentLang == "fr") { this.lang = false }
    this.addressline1 = this.preQualData.users[0].addressline1;
    this.city = this.preQualData.users[0].city;
    this.province = this.preQualData.users[0].province;
    this.postal_code = this.preQualData.users[0].postal_code;
    this.apartment = this.preQualData.users[0]?.apartment;
    let address = this.addressline1 + " " + this.city + " " + this.province + " " + this.postal_code;
    this.createFrmGrp();
    this.addressForm.get('address')?.setValue(address);
    this.valueChanges();
    if (this.isIos) {
      if (sessionStorage.getItem("tempAddressSession")) {
        let details = JSON.parse(sessionStorage.getItem("tempAddressSession"));
        let aptNo = atob(sessionStorage.getItem("aptNo"));
        this.addressForm.controls.streetName.setValue(details.addressline1);
        this.addressForm.controls.apartment.setValue(aptNo);
        this.addressForm.controls.city.setValue(details.city);
        this.addressForm.controls.province.setValue(details.province);
        this.addressForm.controls.postalCode.setValue(details.postal_code);
      }
      this.currentLang = sessionStorage.getItem("currLang")
      this.formUtiObj.InitValues();
    }
  }

  createFrmGrp() {
    this.estimate = new FormGroup({
      estimateValue: new FormControl('', Validators.required),
      // address: new FormControl('', Validators.required)
    });
  }

  valueChanges() {
    this.estimate.get('estimateValue')?.valueChanges.subscribe(val => {
      this.propertyValue = val;
      this.propertyValueNew = Number(this.propertyValue.replace(/[^0-9.]/g, ''));
      if (this.submittedamount && (this.propertyValueNew >= 10000 && this.propertyValueNew <= 1000000)) {
        this.displayValidation = false;
      }
    });
    this.addressForm.get('address')?.valueChanges.subscribe(val => {
      this.selectedRadio = val;
      if (this.selectedRadio === 'other') {
        setTimeout(() => {
          this.initAutocomplete();
        }, 300);
      }
    });
    this.addressForm.get("streetName").valueChanges.subscribe(x => {
      this.address1line = x;
    });
    this.addressForm.get('apartment').valueChanges?.subscribe(val => {
      this.apartmentConfirmed = val;
    });
    this.addressForm.get('city').valueChanges?.subscribe(val => {
      this.cityConfirmed = val;
    });
    this.addressForm.get('province').valueChanges?.subscribe(val => {
      this.provinceConfirmed = val;
    });
    this.addressForm.get('postalCode').valueChanges?.subscribe(val => {
      this.postalConfirmed = val;
    });
  }
  get f() {
    return this.addressForm.controls;
  }
  initAutocomplete() {
    this.address1Field = document.getElementById("streetName") as HTMLInputElement
    this.address2Field = document.querySelector("#address2") as HTMLInputElement;
    this.postalField = document.querySelector("#postcode") as HTMLInputElement;
    this.autocomplete = new google.maps.places.Autocomplete(this.address1Field, {
      componentRestrictions: { country: ["ca"] },
      fields: ["address_components", "geometry"],
    });
    this.autocomplete.addListener('place_changed', () => {
      this.fillInAddress(this.autocomplete.getPlace());
    });
  }
  fillInAddress(place) {
    let address1 = "";
    let postcode = "";
    for (const component of place.address_components as google.maps.GeocoderAddressComponent[]) {
      const componentType = component.types[0];
      switch (componentType) {
        case "street_number": {
          address1 = `${component.long_name} ${address1}`;
          break;
        }
        case "route": {
          address1 += component.short_name;
          break;
        }
        case "postal_code": {
          postcode = `${component.long_name}${postcode}`;
          break;
        }
        case "postal_code_prefix": {
          postcode = `${postcode}${component.long_name}`;
          break;
        }
        case "locality": {
          (document.querySelector("#locality") as HTMLInputElement).value =
            component.long_name;
          this.addressForm.controls.city.setValue(component.long_name);
          if (this.addressForm.controls.city.value) {
            this.cityColor = false
          }

          break;
        }

        case "administrative_area_level_1": {
          for (var province of this.provinceOptions) {
            if (province.code == component.short_name) {

              (document.querySelector("#state") as HTMLInputElement).value =
                component.short_name;

              this.addressForm.controls.province.setValue(component.short_name);
              if (this.addressForm.controls.province.value) {
                this.provinceColor = false
              }
            }
          }
          break;
        }
      }
    }
    this.address1Field.value = address1;
    if (postcode) {
      this.addressForm.controls.postalCode.setValue(postcode);
      this.selCode = true;
    }
    this.postalField.value = postcode;
    this.address2Field.focus();
  }
  validatePostalCode(event) {
    this.selCode = false;
    let postcode: string = this.addressForm.value.postalCode;

    if (postcode.length > 6) {
      if (postcode.includes(' ') && postcode.length >= 7) {
        this.addressForm.controls.postalCode.setValue(postcode.substring(0, 7))
      } else {
        this.addressForm.controls.postalCode.setValue(postcode.substring(0, 6))
      }
    }

    if (event.keyCode === 32 && postcode.length !== 4) {
      this.addressForm.controls.postalCode.setValue(postcode.split(' ').join(''));
      if (postcode.length > 4 && postcode.split(' ').join('').length === 3) {
        this.addressForm.controls.postalCode.setValue(postcode.split(' ').join('') + ' ');
      }
    }

    let testCode: string = postcode.split(' ').join('');
    if (this.codeCheck(event, testCode) === false) {
      this.addressForm.controls.postalCode.setValue(testCode.slice(0, -1));
      this.colorPostal = true;
    } else {
      this.colorPostal = false;
    }
  }
  codeCheck(event, testCode) {
    if (event.key === '!' || event.key === '@' || event.key === '#' || event.key === '$' || event.key === '%' || event.key === '^' || event.key === '&' || event.key === '*' || event.key === '(' || event.key === ')') return false;
    else if (testCode.includes(' ')) {
      if ((testCode.length === 1 || testCode.length === 3 || testCode.length === 6) && ((event.keyCode > 95 && event.keyCode < 106) || (event.keyCode > 47 && event.keyCode < 58) || event.keyCode === 110 || event.keyCode === 111 || event.keyCode === 106 || event.keyCode === 107 || event.keyCode === 109 || event.keyCode === 192 || event.keyCode === 187 || event.keyCode === 189 || event.keyCode === 220 || event.keyCode === 188 || event.keyCode === 190 || event.keyCode === 191 || event.keyCode === 186 || event.keyCode === 110 || event.keyCode === 222 || event.keyCode === 219 || event.keyCode === 221)) return false;
      if ((testCode.length === 2 || testCode.length === 5 || testCode.length === 7) && ((event.keyCode > 64 && event.keyCode < 91) || event.keyCode === 110 || event.keyCode === 111 || event.keyCode === 106 || event.keyCode === 107 || event.keyCode === 109 || event.keyCode === 192 || event.keyCode === 187 || event.keyCode === 189 || event.keyCode === 220 || event.keyCode === 188 || event.keyCode === 190 || event.keyCode === 191 || event.keyCode === 186 || event.keyCode === 110 || event.keyCode === 222 || event.keyCode === 219 || event.keyCode === 221)) return false;
    } else {
      if ((testCode.length === 1 || testCode.length === 3 || testCode.length === 5) && ((event.keyCode > 95 && event.keyCode < 106) || (event.keyCode > 47 && event.keyCode < 58) || event.keyCode === 110 || event.keyCode === 111 || event.keyCode === 106 || event.keyCode === 107 || event.keyCode === 109 || event.keyCode === 192 || event.keyCode === 187 || event.keyCode === 189 || event.keyCode === 220 || event.keyCode === 188 || event.keyCode === 190 || event.keyCode === 191 || event.keyCode === 186 || event.keyCode === 110 || event.keyCode === 222 || event.keyCode === 219 || event.keyCode === 221)) return false;
      if ((testCode.length === 2 || testCode.length === 4 || testCode.length === 6) && ((event.keyCode > 64 && event.keyCode < 91) || event.keyCode === 110 || event.keyCode === 111 || event.keyCode === 106 || event.keyCode === 107 || event.keyCode === 109 || event.keyCode === 192 || event.keyCode === 187 || event.keyCode === 189 || event.keyCode === 220 || event.keyCode === 188 || event.keyCode === 190 || event.keyCode === 191 || event.keyCode === 186 || event.keyCode === 110 || event.keyCode === 222 || event.keyCode === 219 || event.keyCode === 221)) return false;
    }
    return true;
  }
  checkPostal(postal) {
    var regex = new RegExp(/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i);
    if (regex.test(postal.value))
      return true;
    else return false;
  }
  tempAddressSession() {
    sessionStorage.setItem("aptNo", btoa(this.addressForm.value.apartment));
    let applicantAddressObj = {
      city: this.addressForm.value.city,
      province: this.addressForm.value.province,
      addressline1: this.addressForm.value.streetName,
      postal_code: this.addressForm.value.postalCode,
    }
    if (applicantAddressObj.postal_code.trim().indexOf(" ") == -1) {
      applicantAddressObj.postal_code = applicantAddressObj.postal_code.trim().substring(0, 3) + " " + applicantAddressObj.postal_code.trim().substring(3, 6)
    }
    if (this.isIos) {
      sessionStorage.setItem("tempAddressSession", JSON.stringify(applicantAddressObj));
    }
  }
  onContinue() {
    this.submittedamount = true;
    if (this.selectedRadio === 'other') {
      this.submitted = true;
      let f = this.addressForm.controls;

      if (f.streetName.value) {
        this.streetColor = false
      }
      if (f.city.value) {
        if (f.city.errors) {
          f.city.errors.required = false;
        }
        this.cityColor = false
      }
      if (f.province.value) {
        if (f.province.errors) {
          f.province.errors.required = false
        }
        this.provinceColor = false
      }
      if (f.postalCode.value) {
        this.postalColor = false
      }


      var isApplicantValid = !f.streetName.errors?.invalidStreet &&
        !f.apartment.errors?.invalidApartment && !f.city.errors?.invalidCity &&
        !f.postalCode.errors?.pattern && !this.streetColor &&
        !this.cityColor && !this.provinceColor && !this.postalColor && !f.postalCode?.errors && !f.streetName?.errors && !f.apartment?.errors && !f.city.errors && !f.province?.errors;
      if (isApplicantValid) {
        this.address['addressline'] = this.address1line;
        this.address['apartment'] = !this.apartmentConfirmed ? "" : this.apartmentConfirmed;
        this.address['city'] = this.cityConfirmed;
        this.address['province'] = this.provinceConfirmed;
        this.address['postalCode'] = this.postalConfirmed;
        this.preQualData.property_address = this.address;
      }
    }
    else {
      this.address['addressline'] = this.addressline1;
      this.address['apartment'] = !this.apartment ? "" : this.apartmentConfirmed;
      this.address['city'] = this.city;
      this.address['province'] = this.province;
      this.address['postalCode'] = this.postal_code;
      this.preQualData.property_address = this.address;
    }
    if (this.estimate.valid) {
      let propertyValue = Number(this.propertyValue.replace(/[^0-9.]/g, ''));
      propertyValue = this.util.validateCurrency(propertyValue, 8);
      this.propertyValueNew = propertyValue;
      if (this.propertyValueNew >= 10000 && this.propertyValueNew <= 10000000) {
        this.preQualData.property_estimated_value = this.propertyValueNew;
        this.util.setSessionStorage(this.preQualData);
        this.displayValidation = false;
        if (isApplicantValid && this.selectedRadio == 'other' || this.selectedRadio == 'address') {
          this.router.navigate(['../mortgage-detail'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
        }
      }
      else {

        this.util.adobeAnalyticalErrorMsg("estimate-value-of-home", "invalid-amount", "", null);

        this.displayValidation = true;
        const control = this.estimate.get('estimateValue');
        control.markAsDirty();
        control.markAsTouched();
        document.getElementById('estimateValue').focus();
      }
    }

    else if (this.estimate.invalid) {

      this.util.adobeAnalyticalErrorMsg("estimate-value-of-home", "missing", "", null);

      this.displayValidation = true;
      const control = this.estimate.get('estimateValue');
      control.markAsDirty();
      control.markAsTouched();
      document.getElementById('estimateValue').focus();
    }
  }
}
